module.exports = __webpack_public_path__ + "img/video_write.f0d949ba.svg";